<template>
  
  <div>
    <div class="breadcrumb">
      <Breadcrumb separator=">">
        <BreadcrumbItem to="/"> {{ $t("nav.home") }}</BreadcrumbItem>
        <BreadcrumbItem>协定文本</BreadcrumbItem>
      </Breadcrumb>
    </div>

  <div class="results">
    <div class="results-wrap">
      <div class="results-content" >
      
        <ListContent ref="content" class="r-main boxshadow1" style="min-height: 500px;
        max-height: calc(100vh - 300px);
        overflow-y: scroll;"  :dataSet="dataSet" :pageSize="pageSize" :isShowLoader="isShowLoader"></ListContent>
      </div>
    </div>
  </div>
</div>
</template>

<script>

import ListContent from './ListContent'

export default {
  name: 'NewsList',
  components: { ListContent },
  data () {
    return {
      sidebarMinHeight: 0,
      isShowLoader: false,
      pageSize: 10,
      dataSet: [],
      keyword: '',
      categoryID: -1,
      timeStr: '',
      startTime: 0,
      endTime: 0
    }
  },
  watch: {
   
    categoryID (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.getData(1)
      }
    },
    timeStr (newVal, oldVal) {
      if (newVal !== oldVal) {
        if (this._.isEmpty(newVal)) {
          this.startTime = 0
          this.endTime = 0
        } else {
          let tmp = this._.split(newVal, '|')
          this.startTime = parseInt(tmp[0]) || 0
          this.endTime = parseInt(tmp[1]) || 0
        }
        this.getData(1)
      }
    }
  },
 
  mounted () {
    this.$nextTick(() => {
    
      this.requestData()
    })
  },
  methods: {
   
    getData (page) {
     
      page = page || 1
      let key = this._.trim(this.keyword || '')
      let cid = !this.categoryID || this.categoryID === -1 ? '' : this.categoryID
      let startT = this.startTime && this.startTime !== 0 ? this.startTime : ''
      let endT = this.endTime && this.endTime !== 0 ? this.endTime : ''
      this.requestData(this._.assign({page: page}, {size: this.pageSize, key: key, categoryId: cid}))
    },
    delayRequestData (data) {
      setTimeout(() => {
        this.requestData(data)
      }, 500)
    },
   requestData (data) {
    
    
        this.$api.query.getKnowledgeFta({
        success: (response) => {
      
          if (response.data.code === 200) {
           this.dataSet = response.data.data
          
           
        } 
        },
        error: (errorMsg) => {
          this.isShowLoader = false
          this.$Message.error({content: this.$t('common.tryAgain'), closable: true})
          this.$Loading.error()
        }
      });
        
   
     
    },
    
  }
}
</script>
<style scoped>
.breadcrumbs {
  font-size: 14px;
  color: #333;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 18px;
}
.breadcrumbs >>> span span {
  color: #0470e3;
  font-weight: bold;
  cursor: default;
}
.flex {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}
.flex-center {
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;

  justify-content: center;
}
.con {


  color: #ffffff;
}
.con h1 {
  font-size: 40px;
}
.con>>>.ivu-input-group-append, .ivu-input-group-prepend {
  padding: 4px 7px;
  font-size: inherit;
  font-weight: 400;
  line-height: 1;
 
  text-align: center;
 
  border-radius: 6px;
}
.con >>> .ivu-input-wrapper input {
  line-height: 40px !important;
  height: 40px;
}
.con .con-right {
  margin-left: 5%;
  
}
.con .con-right .con-t .con-box {
  font-size: 14px;
  font-weight: 400;
  margin-right: 30px;
}
.con .con-right .con-t .activeBox {
  text-align: center;
  padding: 5px 22px;
  background: #fd6a31;
  border-radius: 4px;
}
.con .con-right .con-m {
  margin: 12px 0;
}
.con .con-right .con-b {
  color: #ffffff;
}
.con .con-right .con-b span {
  font-size: 14px;
  font-weight: 400;
  margin-right: 24px;
}
  .results{
    position: relative;
    padding: 15px 0 25px;
  }
  .results-wrap{
    width:1400px;
    margin: 0 auto;
    padding-bottom: 20px;
   
  }

  .shadow-divide{
    position: absolute;
    top:0;
    left:0;
    width: 100%;
    box-shadow: 0 2px 4px 0 rgba(223,223,223,0.50);
    z-index: 1;
    height: 5px;
    background-color: #fff;
  }
 
  .results-content{
    position: relative;
 
  }
  .r-main{    padding: 20px;}
  .r-sidebar{
    position: absolute;
    top:0;
    left: 0;
    width: 260px;
    min-height: 100%;
    background-color: #fff;
  }
</style>




// WEBPACK FOOTER //
// src/components/ftaList/List.vue